module.exports = __webpack_public_path__ + "178fa1edfdbf4ce9cd39aee88e672ca7.svg";